$( document ).ready(function() {
  
// Left Navigation
$(".openbtn").click(function(e){
            e.stopPropagation();
            $("#mySidenav").css("width", "420px");
        });
$(".closebtn").click(function(e){
            e.stopPropagation();
            $("#mySidenav").css("width",0);
        });
$('#mySidenav').click(function(e){
            e.stopPropagation();
        });
$('body,html').click(function(e){
            $("#mySidenav").css("width",0);
        });
  
  
var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
// End Left Navigation  
// Product Thumbnail Slider
$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  vertical:true,
  asNavFor: '.slider-for',
  dots: false,
  focusOnSelect: true,
  verticalSwiping:true
});
// End Product Thumbnail Slider   
$('.custom-logo').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
$('.feature-product-carousel').slick({
    dots: false,
    arrows: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
$('.custom-instagram-carousel').slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay:true,
    autoplaySpeed:2500,
    arrows:true,
    speed: 600,
    slidesToShow: 6,
    slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
$('.testimonial-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay:true,
    autoplaySpeed:2000,
    arrows:true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
$(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
$('.myslider').slick({

slidesToScroll: 1,
arrows: false,
dots: true,
vertical: true,
verticalSwiping: true
    
});
	  
  
    
$( ".product-img-slide .slider-nav" ).on( "click", function() {

    $( ".product-img-slide .slider-for" ).removeClass('visibility-hidden');
  $( ".product-img-slide .slider-for" ).show();
    $( ".product-img-slide .slider-forr" ).hide();
});
  
  
setTimeout( function(){ 
 $( ".g-variant-color-detail .select-option" ).on( "click", function(e) {
   
    $( ".product-img-slide .slider-for" ).hide();
    $( ".product-img-slide .slider-forr" ).show();
  
   
});
  }  , 1000 );
});



// $( ".img-zoom-image" ).mouseover(function() {
//   let urlzoom = $(this).attr('data-src');
//    $('.img-zoom-image').zoom({url:urlzoom});
//   console.log(urlzoom);
 
// });



	
	$(".zoom-container .zoom").mousemove(function(e){
  
		var x, y;
		var zoomer = e.currentTarget;
		if(e.offsetX) {
			offsetX = e.offsetX;
		} else {
			offsetX = e.touches[0].pageX;
		}

		if(e.offsetY) {
			offsetY = e.offsetY;
		} else {
			offsetX = e.touches[0].pageX;
		}
		x = offsetX/zoomer.offsetWidth*100;
		y = offsetY/zoomer.offsetHeight*100;
		zoomer.style.backgroundPosition = x+'% '+y+'%';
	});

	

